import { Layout, } from "@mcleod/components";

export abstract class AutogenLayoutDemoSnackbarDialog extends Layout {
}
